import { Flex } from "@chakra-ui/react";
import { DisplayField } from "src/components/shared/DisplayField";
import { IAdjudicationFormSubmission, IEarlyAssessmentFormSubmission } from "@publishing-engine/domain/models";

const AssessmentOptIns = ({ earlyAssessment, config }: {
  earlyAssessment: IEarlyAssessmentFormSubmission | IAdjudicationFormSubmission,
  config: any
}) => {
  const formConfigs = {
    PeerReviewTransparency: config.PeerReviewTransparency,
    ReviewerAnonymity: config.ReviewerAnonymity,
    WebOfScienceOptIn: config.WebOfScienceOptIn
  };

  return (
    <Flex direction='column'>
      {earlyAssessment?.peerReviewTransparency && (
        <DisplayField
          fieldName="PeerReviewTransparency"
          value={earlyAssessment?.peerReviewTransparency}
          config={formConfigs}
        />
      )}
      {earlyAssessment?.reviewerAnonymity && (
        <DisplayField
          fieldName="ReviewerAnonymity"
          value={earlyAssessment?.reviewerAnonymity}
          config={formConfigs}
        />
      )}
      {earlyAssessment?.webOfScienceOptIn && (
        <DisplayField
          fieldName="WebOfScienceOptIn"
          value={earlyAssessment?.webOfScienceOptIn}
          config={formConfigs}
        />
      )}
    </Flex>
  )
}

export default AssessmentOptIns;